export default {

  SET_QUARTERS (state, quarters) {
    state.quarters = quarters
  },

  SET_SECTORS (state, sectors) {
    state.sectors = sectors
  },

  SET_CLASSIFICATIONS (state, classifications) {
    state.classifications = classifications
  },

  SET_COUNTRIES (state, countries) {
    state.countries = countries
  },
  SET_GLOBAL_COUNTRIES (state, countries) {
    state.global_countries = countries
  },
  SET_GLOBAL_EXCHANGES (state, countries) {
    state.global_exchanges = countries
  },
  SET_STOCK_COUNTRIES (state, countries) {
    state.stock_countries = countries
  },

  SET_SEC_CODE_STATES (state, secCodeStates) {
    state.secCodeStates = secCodeStates
  },

  SET_STATES (state, states) {
    state.states = states
  },

  SET_WW_GROUPS (state, wwGroups) {
    state.wwGroups = wwGroups
  },

  SET_OWNERSHIP_T_CODES (state, ownershipTCodes) {
    state.ownershipTCodes = ownershipTCodes
  },

  SET_NEWS (state, news) {
    state.news = news
  }

}
